import { supabase } from './supabase'

const FUNCTION_URL = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/send-email`
const CREATE_STAFF_URL = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-staff-user`

async function callEmailFunction(type, payload) {
  const { data: { session } } = await supabase.auth.getSession()
  const res = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session?.access_token || ''}`,
    },
    body: JSON.stringify({ type, ...payload }),
  })
  return res.json()
}

export const sendWelcomeEmail = (payload) => callEmailFunction('welcome', payload)
export const sendReminderEmail = (payload) => callEmailFunction('reminder', payload)
export const sendBulkReminders = (payload) => callEmailFunction('bulk-reminders', payload)
export const sendSeasonEndingEmails = (payload) => callEmailFunction('season-ending', payload)
export const sendSeasonEndedEmails = (payload) => callEmailFunction('season-ended', payload)
export const sendInviteEmail = (payload) => callEmailFunction('invite', payload)

export const createStaffUser = async (email, password) => {
  const { data: { session } } = await supabase.auth.getSession()
  const res = await fetch(CREATE_STAFF_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session?.access_token || ''}`,
    },
    body: JSON.stringify({ email, password }),
  })
  return res.json()
}